import { cn } from "../lib/utils";
import Smiley from "./illustrations/Smiley";

const EmptyStore = ({ store, search = false, searchQuery = "" }) => (
  <div
    className={cn(
      "flex w-full items-center justify-center",
      search && "items-start",
      !search && "flex-col",
    )}
  >
    <div className="mt-[10vh] flex w-[calc(var(--max-width)-200px)] flex-col items-center justify-center">
      <Smiley className="mt-12 size-[96px]" color="var(--font-background)" />

      {search ? (
        <div className="mt-4 text-center text-[20px] italic leading-[1.5] text-fontBackground">
          Looks like we don’t have <b>{searchQuery}</b>.
          <br />
          Check the spelling or try a different item.
        </div>
      ) : (
        <>
          <div className="mt-5 text-center text-[28px] font-bold text-fontBackground">
            Oh deer, it’s empty!
          </div>
          <div className="mt-2 text-center text-[16px] italic leading-[1.5] text-fontBackground">
            {store?.store?.storeName} haven't added any
            <br /> products to their shop yet.
            <br /> If you'd like to see them here, we'd
            <br /> love for you to drop them an invite.
          </div>
        </>
      )}
    </div>

    {!search && (
      <a
        href={`instagram://user?username=${store?.store?.contactInfo?.instagramHandle}`}
        className="mt-6 rounded-lg border border-primary bg-primary px-14 py-2.5 text-fontPrimary hover:cursor-pointer"
      >
        INVITE
      </a>
    )}
  </div>
);

export default EmptyStore;
